import { Asset as CfAsset } from "nvs-types/dist/types/generated/contentful";

/**
 * Takes in Contentful asset url and returns a local path with the image id from Contentful
 */
export const createLocalAssetUrl = (contentfulAssetUrl: string) => {
  const idFromImageURL = contentfulAssetUrl.replace(
    /^https:\/\/images.ctfassets.net\/.+?\/(.+?)?\/.+\/.+\.(jpg|png|svg)/,
    "$1",
  );
  return `/assets/${idFromImageURL}`;
};

export function isUnoptimizedImageEnv() {
  return !!process.env.NEXT_PUBLIC_UNOPTIMIZED_IMAGES;
}

export const getBlurDataURL = (asset: CfAsset) =>
  `/_next/image?url=${asset.url}&w=16&q=10`;
